import { Outlet } from "react-router";

import { AppSidebar } from "@/components/AppSidebar";
import { Header } from "@/components/Header";
import { SidebarProvider, SidebarWrapper } from "@/components/ui/sidebar";

export const Layout = () => {
  return (
    // TODO: test this on mobile - is dvh and dvw correct? or should we use h-screen/w-screen (which use vh/vw)
    <SidebarProvider>
      <div className="grid grid-cols-[1fr] grid-rows-[auto_1fr] h-dvh w-dvw overflow-hidden">
        <Header />
        <div className="overflow-auto">
          <SidebarWrapper className="relative h-full min-h-auto">
            <AppSidebar className="absolute h-full" />
            <main className="p-6 overflow-auto w-full">
              <Outlet />
            </main>
          </SidebarWrapper>
        </div>
      </div>
    </SidebarProvider>
  );
};
